<template>
    <div class="page-container page-footer">
        <div class="contact">
            <div v-if="preset.app && preset.app.contact" v-html="preset.app.contact"></div>
            <div v-else-if="$organization.org == 'sjtu'" class="">
                联系方式： <i class="fa fa-phone"></i> 34206060 <i class="fa fa-map-signs"></i> ：上海市东川路800号
                <span class="ml-3">©2019</span>&nbsp;
                <a style="color: black" href="http://net.sjtu.edu.cn">上海交通大学网络信息中心</a>&nbsp;
                <a href="mailto:service@sjtu.edu.cn" style="color: black">service@sjtu.edu.cn</a><br/>
                支持以下浏览器版本：IE版本9以上，Chrome，Safari，Firefox，Edge，国内浏览器请使用极速模式。
            </div>
            <div v-else-if="$organization.org == 'ecupl'">
                联系方式： <i class="fa fa-phone"></i> 57090561(松江) 62071629(长宁) <i class="fa fa-map-signs"></i>
                松江校区：松江大学园区龙源路555号 <i class="fa fa-map-signs"></i> 长宁校区：万航渡路1575号
                <br/><span class="ml-3">©2019</span>&nbsp;上海华东政法大学信息化办公室
            </div>
            <div v-else-if="$organization.org == 'ecnu'">
                <div class="logo-address text-center">
                    <a href="https://eoffice.ecnu.edu.cn/" target="_blank">技术支持：华东师范大学 信息化治理办公室</a>
                    | 联系电话：62233081 邮箱：its@ecnu.edu.cn | 沪ICP备05003394 <br/>
                    支持的浏览器有：IE版本9以上，Chrome,Safari,Firefox，国内浏览器请使用极速模式。 |
                    <a href="/privacy" target="_blank"><i class="el-icon-s-custom"/> 隐私政策</a>
                </div>
            </div>
            <div v-else>
                支持的浏览器版本：IE版本9以上，Chrome，Safari，Firefox，Edge，国内浏览器请使用极速模式。
            </div>
        </div>
    </div>
</template>

<script>
import CommonMixin from "../common/mixins/common-mixin";

export default {
    name: "page-footer",
    mixins: [CommonMixin],
    props: {
        mobile: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
}
</script>

<style lang="scss">
.page-footer {
    height: 87px;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
